import React from "react";
import { LockSimple } from "@phosphor-icons/react";
import { openGate, useAppAuthed } from "../lib/gate";

export const LockedBlur = ({ children, testid = "locked-blur", label = "Your results are ready" }) => {
  const authed = useAppAuthed();
  if (authed) return children;
  return (
    <div data-testid={testid} className="relative">
      <div aria-hidden className="blur-md select-none pointer-events-none opacity-70">{children}</div>
      <div data-gate-ui className="absolute inset-0 flex items-start justify-center pt-16 px-4">
        <div className="card-surface p-6 sm:p-8 max-w-sm text-center shadow-2xl">
          <LockSimple size={28} weight="thin" className="text-exodus-gold mx-auto" />
          <p className="font-display text-2xl mt-3">{label}</p>
          <p className="text-sm text-exodus-muted mt-2">Create free access to see your numbers and save them.</p>
          <button data-testid={`${testid}-unlock`} onClick={openGate} className="btn-gold w-full justify-center mt-5">Unlock my results</button>
        </div>
      </div>
    </div>
  );
};
